import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
import {AIChatBox, AIChatBoxConfig} from "./AIChatBox.js";
import {RAGResults} from "./RAGResults.js";
import {acceptParentMessage, postToParent} from "../IframeParentOrigin.js";
const $ = jQuery;

export class ZIDXRAGChat implements ZIDXPage {
    zidx: ZIDX;
    private aiBotId: string = "";
    private aiSessionId: string | null = null;
    private aiChatBox: AIChatBox | null = null;
    private pageContainer: HTMLElement | null = null;

    constructor(zidx: ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxRAGChatContainer";
    }

    render() {
        console.log("RAGChat");
        const self = this;
        const pageContainer = $("." + this.getPageClass() + ".zidxPageActive", this.zidx.peakidxShadowRoot)[0];
        if (!pageContainer) return;
        this.pageContainer = pageContainer;
        const pageMarginContainer = $("." + this.getPageClass() + ".zidxPageActive .zidxPageMargin", this.zidx.peakidxShadowRoot)[0];
        if (!pageMarginContainer) return;

        this.aiBotId = pageMarginContainer.getAttribute("data-ai-bot-id") || "";
        if (!this.aiBotId){
            console.log("aiBotId missing");
            return;
        }

        const chatEmbed = $("." + this.getPageClass() + ".zidxPageActive .aifcChatEmbed", this.zidx.peakidxShadowRoot)[0];
        if (!chatEmbed) {
            console.log("Chat Embed Missing");
            return;
        }

        const restoreSessionId = this.getSessionIdFromContainer(pageContainer);

        const config = new AIChatBoxConfig();
        const customPlaceholder = pageMarginContainer.getAttribute("data-placeholder") || "";
        if (customPlaceholder) {
            config.placeholder = customPlaceholder;
        }
        const skinned = pageMarginContainer.getAttribute("data-idx-ai-skin") === "1";
        config.clearPlaceholderAfterFirstReply = skinned;
        if (skinned) {
            this.initEmbedCloseHandshake(pageContainer);
        }
        config.aiEndPointURL = "/rag-chat-stream/";
        config.aiBotId=parseInt(this.aiBotId)||0;
        config.feedbackURL = "/ai-chat-feedback/";
        config.extraQueryParams = "&ai_bot_id=" + encodeURIComponent(this.aiBotId);
        if (pageMarginContainer.getAttribute("data-debug") === "1") {
            config.extraQueryParams += "&debug=1";
        }

        // Triggers AIChatBox.loadSessionHistory() -> renderHistoryMessages() -> onHistoryLoaded
        if (restoreSessionId) {
            config.initialSessionId = restoreSessionId;
            this.aiSessionId = restoreSessionId;
        }

        // Fires once the backend assigns/confirms the session id (new or restored)
        config.onSessionReady = (sessionId: string) => {
            self.aiSessionId = sessionId;
            self.pushSessionURL(sessionId);
        };

        config.onPromptCallback = (prompt: string) => prompt;
        config.onText = (data: string): string => data;
        config.onJSON = (data: any) => {};
        config.onXML = (data: string) => {};

        config.onHistoryLoaded = (messages: any[]) => {
            // renderHistoryMessages leaves stale loading dots behind; strip them.
            $(".aifcChatLoadingDots", self.zidx.peakidxShadowRoot).remove();
            $(self.zidx.peakidxShadowRoot).find("#aifcCurrentLoader").remove();

            // RAG chat has no results grid to replay, so nothing else to do here —
            // unlike AISearchIntegration which has to re-run the property search.
        };

        config.onDataCompleteCallback = () => {};

        // Optional "AI Overview" + Google-style search results panel (ai_bot_show_search_results)
        if (pageMarginContainer.getAttribute("data-show-search-results") === "1") {
            config.overviewLabel = pageMarginContainer.getAttribute("data-overview-label") || "AI Overview";
            config.overviewCollapse = pageMarginContainer.getAttribute("data-overview-collapse") !== "0";
            // the panel is a sibling below the chat embed (thread + prompt field)
            const panel = document.createElement("div");
            panel.className = "idx-ai-results";
            panel.style.display = "none";
            chatEmbed.parentElement!.insertBefore(panel, chatEmbed.nextSibling);
            const results = new RAGResults(this.zidx, panel, config.aiBotId, () => self.aiSessionId);
            config.onSearchQuery = (query: string) => results.show(query);
            const baseHistoryLoaded = config.onHistoryLoaded;
            config.onHistoryLoaded = (messages: any[]) => {
                baseHistoryLoaded(messages);
                // restore the last search of the conversation (page 1), no LLM call needed
                for (let i = messages.length - 1; i >= 0; i--) {
                    const m = messages[i];
                    if (m.role === "assistant" && m.toolInput) {
                        results.show(String(m.toolInput));
                        break;
                    }
                }
            };
        }

        this.aiChatBox = new AIChatBox(this.zidx, config, this.zidx.peakidxShadowRoot, chatEmbed, function() {});
        console.log("aiChatBox", config, chatEmbed);
    }

    /**
     * Custom skins draw their own close button. It is only shown when the embedding page confirms it can
     * close the modal: the parent sends {source:"peakidx-embed", type:"hello"} when the iframe loads, and the
     * chat replies {source:"peakidx-chat", type:"custom-close"} so the parent hides its own close button.
     * Parents that never send "hello" (old embeds, standalone visits) keep their own behavior.
     */
    private initEmbedCloseHandshake(pageContainer: HTMLElement) {
        if (window.parent === window) return;
        const closeButton = $(".idx-ai-close", pageContainer)[0] as HTMLElement | undefined;
        if (!closeButton) return;
        closeButton.addEventListener("click", (e) => {
            e.preventDefault();
            postToParent({source: "peakidx-chat", type: "close"});
        });
        window.addEventListener("message", (event: MessageEvent) => {
            if (!acceptParentMessage(event)) return;
            const data = event.data;
            if (!data || data.source !== "peakidx-embed" || data.type !== "hello") return;
            pageContainer.classList.add("idx-ai-has-close");
            postToParent({source: "peakidx-chat", type: "custom-close"});
        });
        // The parent may have sent "hello" before this listener existed, so ask for it again.
        postToParent({source: "peakidx-chat", type: "ready"});
    }

    private getSessionIdFromContainer(pageContainer: HTMLElement): string | null {
        // During SPA navigation, window.location is NOT yet updated when render() runs
        // (pushState fires afterward in a setTimeout inside renderResponse). The URL the
        // SPA is loading is on the active container's data-last-url, set before render().
        const lastURL = pageContainer.getAttribute("data-last-url") || "";
        const qIdx = lastURL.indexOf("?");
        // If data-last-url has no query string, there is genuinely no sessionId —
        // do NOT fall back to window.location.search, that's the stale value.
        const search = qIdx !== -1 ? lastURL.substring(qIdx) : "";

        const fromQuery = new URLSearchParams(search).get("sessionId");
        if (fromQuery && /^[a-zA-Z0-9_-]+$/.test(fromQuery)) {
            return fromQuery;
        }
        return null;
    }

    private pushSessionURL(sessionId: string) {
        if (!this.pageContainer
            || !this.pageContainer.classList.contains("zidxPageActive")
            || !(this.zidx.peakidxShadowRoot as ParentNode).contains(this.pageContainer)) {
            return;
        }
        const lastURL = this.pageContainer.getAttribute("data-last-url") || "";
        const url = new URL(this.zidx.options.siteDomain+lastURL);
        if (url.searchParams.get("sessionId") === sessionId) return;
        url.searchParams.set("sessionId", sessionId);
        // lastURL is root-relative; keep the site prefix (wordpress proxy, cdn) in the browser address
        window.history.replaceState({ ragChatSession: sessionId }, "", this.zidx.getPrefixURL(url.pathname) + url.search + url.hash);
    }
}
